import React from 'react'
import { colors, spacing, borderRadius, shadows } from '../styles/design-system'

interface AdminFilterTriggerProps {
  onClick: () => void
  label?: string
  hasActiveFilters?: boolean
  className?: string
}

const AdminFilterTrigger: React.FC<AdminFilterTriggerProps> = ({
  onClick,
  label = 'Abrir filtros',
  hasActiveFilters = false,
  className = ''
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '44px',
        height: '44px',
        borderRadius: borderRadius.lg,
        border: `1px solid ${colors.neutral.gray200}`,
        backgroundColor: colors.neutral.white,
        color: colors.neutral.gray600,
        position: 'relative' as const,
        boxShadow: shadows.sm,
        transition: 'all 0.2s ease-in-out',
        padding: spacing.sm,
        cursor: 'pointer'
      }}
      onMouseEnter={(event) => {
        event.currentTarget.style.backgroundColor = colors.neutral.gray50
        event.currentTarget.style.color = colors.primary.blue
        event.currentTarget.style.borderColor = colors.primary.blue
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.backgroundColor = colors.neutral.white
        event.currentTarget.style.color = colors.neutral.gray600
        event.currentTarget.style.borderColor = colors.neutral.gray200
      }}
      aria-label={label}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 4h18" />
        <path d="M6 12h12" />
        <path d="M10 20h4" />
      </svg>
      {hasActiveFilters && (
        <span
          style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            width: '10px',
            height: '10px',
            borderRadius: borderRadius.full,
            backgroundColor: colors.primary.yellow,
            border: `2px solid ${colors.neutral.white}`
          }}
          aria-hidden="true"
        />
      )}
      <span style={{ position: 'absolute', overflow: 'hidden', clip: 'rect(0,0,0,0)', width: '1px', height: '1px' }}>
        {label}
      </span>
    </button>
  )
}

export default AdminFilterTrigger

